import React, { useEffect, useRef } from 'react';

const GoogleSignIn = ({ onSuccess, onError, buttonText = 'Sign in with Google' }) => {
  const googleDivRef = useRef(null);
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  useEffect(() => {
    console.log('GoogleSignIn: Client ID =', googleClientId);

    if (!googleClientId) {
      console.log('GoogleSignIn: No client ID found');
      return;
    }

    const existing = document.getElementById('google-identity-script');

    const init = () => {
      try {
        console.log('GoogleSignIn: Initializing Google One Tap with client ID =', googleClientId);

        // Initialize Google One Tap (works in PWA standalone mode)
        // eslint-disable-next-line no-undef
        window.google?.accounts.id.initialize({
          client_id: googleClientId,
          callback: async (response) => {
            const idToken = response?.credential;
            if (!idToken) return;

            try {
              if (onSuccess) {
                await onSuccess(response);
              }
            } catch (err) {
              if (onError) {
                onError(err);
              }
            }
          },
          // Callback-based approach works in both browser and PWA
          context: buttonText === 'Sign up with Google' ? 'signup' : 'signin'
        });

        // Render the button
        if (googleDivRef.current) {
          // eslint-disable-next-line no-undef
          window.google?.accounts.id.renderButton(googleDivRef.current, {
            theme: 'outline',
            size: 'large',
            width: '320',
            text: buttonText === 'Sign up with Google' ? 'signup_with' : 'signin_with',
            shape: 'rectangular',
            logo_alignment: 'left'
          });
        }

        console.log('GoogleSignIn: Google One Tap initialized successfully');
      } catch (_e) {
        console.error('GoogleSignIn: Error initializing', _e);
        if (onError) onError(new Error('Failed to initialize Google Sign-In'));
      }
    };

    if (!existing) {
      const s = document.createElement('script');
      s.id = 'google-identity-script';
      s.src = 'https://accounts.google.com/gsi/client';
      s.async = true;
      s.defer = true;
      s.onload = init;
      s.onerror = () => {
        console.error('GoogleSignIn: Failed to load Google Sign-In script');
        if (onError) onError(new Error('Failed to load Google Sign-In script'));
      };
      document.body.appendChild(s);

      return () => {
        if (document.body.contains(s)) {
          document.body.removeChild(s);
        }
      };
    } else {
      init();
    }
  }, [googleClientId, onSuccess, onError, buttonText]);

  return <div ref={googleDivRef} id="googleSignInDiv" />;
};

export default GoogleSignIn;